import styled from 'styled-components';

import Button from 'components/Button';

export const Container = styled.div`
  display: flex;
  align-items: center;
  column-gap: 2px;
  z-index: 2;
  height: 55px;
`;

export const CopyButton = styled(Button)`
  padding: 8px;
  min-width: 30px;
  min-height: 30px;
`;

export const TextWrapper = styled.div<{ $isPointer: boolean }>`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: clip;
  cursor: ${({ $isPointer }) => ($isPointer ? 'pointer' : 'auto')};
`;
